import { proxyAPI } from 'API/httpClient';

/**
 * Used to determine the Guesty capital status of a current user
 * @returns
 * oneof [ "eligible", "not_eligible", "offer_accepted" ]
 */
export const getCapitalStatus = async (): Promise<
  'eligible' | 'not_eligible' | 'offer_accepted'
> => {
  const { data } = await proxyAPI.get('/gfh/capital/get-status-by-account');
  return data.status;
};

export default getCapitalStatus;
